import React from 'react';
import {Link, useCart, useLocalization} from '@shopify/hydrogen';
import type {Product as ProductType} from '@shopify/hydrogen/storefront-api-types';
import * as R from 'ramda';
import clsx from 'clsx';
import Product from '../custom/Product.client';

// @ts-expect-error
import {Swiper, SwiperSlide} from 'swiper/react';
// @ts-expect-error
import {Swiper as SwiperClass} from 'swiper/types';

export default function CartRecommendation() {
  const {
    language: {isoCode: languageCode},
    country: {isoCode: countryCode},
  } = useLocalization();
  const {lines} = useCart();
  const firstProductId =
    lines &&
    !R.isEmpty(lines) &&
    (lines[0].merchandise.product as ProductType).id;

  const [products, setProducts] = React.useState<ProductType[]>([]);

  const getRecommendation = async () => {
    try {
      const res = await fetch('/api/cart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({gid: firstProductId, countryCode, languageCode}),
      });
      const data = await res.json();
      await setProducts(data.data.productRecommendations);
    } catch (error) {
      console.log(error);
    }
  };

  const [activeIndex, setActiveIndex] = React.useState(0);
  const carouselRef = React.useRef<SwiperClass>(null);

  React.useEffect(() => {
    if (firstProductId) {
      getRecommendation();
    }
  }, [lines]);

  const hasSlides = products && !R.isEmpty(products);
  const lastIndex = hasSlides && products.length - 5;
  const SwiperCarousel: SwiperClass = Swiper;

  if (hasSlides) {
    return (
      <div className="">
        <header className="">
          <h5 className="uppercase text-xl text-center mb-6 font-bold">
            You may also like
          </h5>
        </header>
        <div className="relative max-w-[250px] mx-auto md:max-w-none">
          <div className="px-10">
            <SwiperCarousel
              slidesPerView={5}
              spaceBetween={30}
              ref={carouselRef}
              breakpoints={{
                320: {
                  spaceBetween: 0,
                  slidesPerView: 1,
                },
                768: {
                  spaceBetween: 30,
                  slidesPerView: 5,
                },
              }}
              onSlideChange={(swiper: SwiperClass) => {
                const nextSlide = swiper.activeIndex;
                setActiveIndex(nextSlide);
              }}
            >
              {products &&
                !R.isEmpty(products) &&
                products.map((p) => {
                  return (
                    <SwiperSlide
                      key={`cart-recommended-${p.handle}`}
                      className="!h-auto"
                    >
                      <Product storefrontProduct={p} />
                    </SwiperSlide>
                  );
                })}
            </SwiperCarousel>
          </div>
          {hasSlides && products.length > 5 && (
            <button
              onClick={() => carouselRef.current?.swiper.slidePrev()}
              className={clsx(
                'absolute left-0 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2',
                activeIndex === 0 && 'pointer-events-none opacity-50',
              )}
            >
              <svg
                width="35"
                viewBox="0 0 48 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse
                  rx="24"
                  ry="22.5905"
                  transform="matrix(1 0 0 -1 24 22.5902)"
                  fill="#212121"
                />
                <path
                  d="M26.3546 30.0863L27.0865 29.4315C27.2329 29.2592 27.2329 28.9835 27.0865 28.8456L20.463 22.6076L27.0865 16.335C27.2329 16.1972 27.2329 15.9214 27.0865 15.7491L26.3546 15.0943C26.1717 14.922 25.9155 14.922 25.7325 15.0943L18.0477 22.2974C17.9014 22.4697 17.9014 22.7109 18.0477 22.8833L25.7325 30.0863C25.9155 30.2587 26.1717 30.2587 26.3546 30.0863Z"
                  fill="white"
                />
              </svg>
            </button>
          )}
          {hasSlides && products.length > 5 && (
            <button
              onClick={() => carouselRef.current?.swiper.slideNext()}
              className={clsx(
                'absolute right-0 top-1/2 z-10 translate-x-1/2 -translate-y-1/2',
                activeIndex === lastIndex && 'pointer-events-none opacity-50',
              )}
            >
              <svg
                width="35"
                viewBox="0 0 48 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <ellipse
                  cx="24"
                  cy="22.5902"
                  rx="24"
                  ry="22.5905"
                  fill="#212121"
                />
                <path
                  d="M22.2204 15.4155L21.5199 16.0422C21.3798 16.2071 21.3798 16.471 21.5199 16.603L27.8595 22.5737L21.5199 28.5774C21.3798 28.7094 21.3798 28.9733 21.5199 29.1382L22.2204 29.765C22.3955 29.9299 22.6407 29.9299 22.8158 29.765L30.1713 22.8706C30.3114 22.7057 30.3114 22.4748 30.1713 22.3098L22.8158 15.4155C22.6407 15.2505 22.3955 15.2505 22.2204 15.4155Z"
                  fill="white"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    );
  }
  return null;
}
